// Shared squarish status/tag chip — tinted background, solid border,
// matching text colour. Used instead of DaisyUI's pill-shaped `badge` for
// status/category indicators, matching the pattern used in Connektiv8 and
// Clinical Outcomes.
export type ChipTone = 'neutral' | 'warning' | 'info' | 'success' | 'error';

const TONE_CLASSES: Record<ChipTone, string> = {
  neutral: 'bg-base-content/10 border-base-content/20 text-base-content/60',
  warning: 'bg-warning/15 border-warning text-warning',
  info:    'bg-info/15 border-info text-info',
  success: 'bg-success/15 border-success text-success',
  error:   'bg-error/15 border-error text-error',
};

interface ChipProps {
  label: string;
  tone?: ChipTone; // ignored if `color` is given
  color?: string;   // arbitrary hex, e.g. a per-session-type colour
  title?: string;
}

export default function Chip({ label, tone, color, title }: ChipProps) {
  if (color) {
    return (
      <span
        className="inline-block rounded border px-2 py-0.5 text-xs font-medium"
        style={{ backgroundColor: `color-mix(in oklch, ${color} 15%, transparent)`, borderColor: color, color }}
        title={title}
      >
        {label}
      </span>
    );
  }
  return (
    <span className={`inline-block rounded border px-2 py-0.5 text-xs font-medium ${TONE_CLASSES[tone ?? 'neutral']}`} title={title}>
      {label}
    </span>
  );
}
